export default {
  getParams_getValue(value) {
    if (value === undefined || value === null) {
      return "";
    }
    else {
      return value;
    }
  }
}